export default __webpack_public_path__ + "static/media/pic12-1.7f462997.jpg";